import { Box, BoxProps, Image, Text, TextProps } from '@jfs/ui-new'
import sort_decreasing from '../../assets/images/Decreasing.png'
import sort_increasing from '../../assets/images/Increasing.png'
import sort_inactive from '../../assets/images/sort_inactive.png'
import { tableItemStrings } from '../../data/static/strings'
import { ActionType, isStringBlank } from '../../util/util'
import { getActionView } from './getActionView'
import { CopyView } from './getCopyView'
import { getDateView } from './getDateView'
import { getDeleteView } from './getDeleteView'
import { getDownloadAsView } from './getDownloadAsView'
import { getDownloadDeleteView } from './getDownloadDeleteView'
import { getDownloadView } from './getDownloadView'
import { getEditDeleteView } from './getEditDeleteView'
import { getProcessView } from './getProcessView'
import { getRefundProcessView } from './getRefundProcessView'
import { styles } from './styles'

const getWidth = (id: string, extendedColumns: any): BoxProps => {
  if (extendedColumns?.includes(id)) {
    return id === 'url' ||
      id === 'file' ||
      id === 'campaignTitle' ||
      id === 'requestId' ||
      id === 'fileName' ||
      id === 'downloadDelete'
      ? styles.extendedExtraWidth
      : styles.extendedWidth
  }
  if (id === 'failureReason') {
    return styles.longGrid
  }
  if (id === 'srno') {
    return styles.smallColumnWidth
  }
  return {}
}

function hasKey<O>(obj: O, key: string | number | symbol): key is keyof O {
  return key in obj
}

const valueMapperWithColor = (passedValue: string) => {
  //to fix crash on value as function
  if (typeof passedValue === 'string') {
    const value = passedValue?.toUpperCase()
    if (
      value?.includes('ACCEPTED') ||
      value?.includes('SUCCESS') ||
      value?.includes('ACTIVE') ||
      value?.includes('PROCESSED')
    ) {
      return 'SUCCESS'
    } else if (value?.includes('FAILED') || value?.includes('FAILURE') || value?.includes('CANCELED')) {
      return 'FAILURE'
    } else if (value?.includes('INITIATED') || value?.includes('PENDING')) {
      return 'PENDING'
    }
  }
  return null
}

const ItemView = (
  entry: any,
  handleSort: any,
  extedndedColumns: any,
  from: string,
  transactionType: number,
  data: any,
  isHovering: boolean,
  copied: boolean,
  setCopied: any,
  isFreeze?: boolean,
  freezeColumn?: any,
  sortDetails?: any,
  onAction?: any,
  onDownloadFileAction?: any,
  onChangeInput?: any,
  onDownloadReportFile?: any,
  onDeleteReportFile?: any,
  onEditReport?: any,
) => {
  const ernTextStyle = transactionType === 4 ? styles.ernTitle : styles.title
  const textStyles = data.id === '0' ? styles.titleHeader : styles.title
  const viewStylesInner = data.id === '0' ? styles.titleheaderView : styles.titleView
  const sort = () => {
    if (handleSort) {
      handleSort(entry.id)
    }
  }

  const extedndedWidth = getWidth(entry.id, extedndedColumns)

  const split = from === 'ops' ? entry.value?.toString().split(',') : entry.value

  let value = entry.value
  let bubbleValue
  if (!!split && split?.length > 0 && from === 'ops') {
    value = split[0]
    if (split?.length === 2) {
      bubbleValue = split[1]
    }
  }

  // Fix for rendering empty column in table as links are empty
  if (
    entry.id === tableItemStrings.id ||
    entry.id === tableItemStrings.links ||
    entry.id === tableItemStrings.loading ||
    (entry.id === 'fileName' && transactionType === 1) ||
    (!isFreeze && entry.id === freezeColumn) ||
    entry.id === 'disabled'
  ) {
    return null
  } // id values are need not to render in table
  let statusStyle: any
  const migratedStyle = typeof value === 'string' ? valueMapperWithColor(value) : value

  if (hasKey(styles, migratedStyle)) {
    statusStyle = styles[migratedStyle.toString()]
  }

  if (entry.id === tableItemStrings.extendedData) {
    value = value.slice(0, 15) // Fix for overllaping issue when extendedData is applied from fieldSettings
  }

  const getSortImage = () => {
    const getImage = {
      [tableItemStrings?.decreasingSortOrder]: sort_decreasing,
      [tableItemStrings?.increasingSortOrder]: sort_increasing,
      [tableItemStrings?.noSortOrder]: sort_inactive,
    }

    if (entry.id === sortDetails?.key) {
      return getImage[sortDetails?.order ?? tableItemStrings?.noSortOrder]
    }
    return getImage[tableItemStrings?.noSortOrder]
  }

  const BubbleView = ({ label, hide = true }: any) => {
    if (hide) {
      return null
    }
    return (
      <Box {...styles.ovalShapeView}>
        <Text {...styles.bubbleTextStyle}>{isStringBlank(label) ? 'NA' : label}</Text>
      </Box>
    )
  }

  const defaultView = (isEmptyAllowed: boolean = false) => {
    const actualValue = typeof entry?.value === 'string' ? entry?.value?.trim() : entry?.value
    const placeHolder = isEmptyAllowed ? '' : 'N/A'
    return (
      <Box {...statusStyle} justifyContent="center" f={1} testID={actualValue}>
        <Text
          numberOfLines={1}
          {...(tableItemStrings.link?.includes(entry.id) ? styles.linkStyle : textStyles)}
          color={tableItemStrings.link?.includes(entry.id) ? 'BLUE' : styles[actualValue]?.color}>
          {typeof actualValue === 'function' && <entry.value data={data} />}
          {typeof entry.value !== 'function' &&
            `${actualValue === undefined || actualValue === '' ? placeHolder : actualValue}`}
        </Text>
      </Box>
    )
  }

  const getErnView = (ern: any) => {
    return <Text {...ernTextStyle}>{isStringBlank(ern) ? 'NA' : ern}</Text>
  }

  const executeAction = (actionType: ActionType) => {
    if (onAction) {
      onAction(actionType, data.id)
    }
  }

  const getStatus = () => {
    const getValue: any = {
      generated: false,
      processed: false,
    }
    if (data?.fileStatus) {
      return getValue[data?.fileStatus] ?? true
    }
    return false
  }

  const downloadFileAction = (filetype: string) => {
    if (onDownloadFileAction) {
      onDownloadFileAction(filetype, data.id)
    }
  }

  const deleteReportFile = () => {
    if (onDeleteReportFile) {
      onDeleteReportFile(data)
    }
  }

  const downloadReportFile = () => {
    if (onDownloadReportFile) {
      onDownloadReportFile(data)
    }
  }

  const editReportFile = () => {
    if (onEditReport) {
      onEditReport(data)
    }
  }

  const onChangeText = (text: string) => {
    if (onChangeInput) {
      onChangeInput(data?.rrn, text)
    }
  }

  const getRewardView = (item: any, style?: TextProps) => {
    const values = item?.toString()?.split('/')
    if (!values || values.length === 0) {
      return null
    }
    return (
      <Box f={1}>
        <Text {...style}>
          {values[0]}
          {values?.length > 1 && <Text {...style} opacity={0.6}>{`/${values[1]}`}</Text>}
        </Text>
      </Box>
    )
  }
  const getAction = () => {
    const getView: { [key: string]: any } = {
      download: getDownloadView(entry.value, executeAction),
      process: getProcessView(entry, executeAction),
      delete: getDeleteView(entry, executeAction),
      refundProcess: getRefundProcessView(entry, onChangeText, data),
      fileName: getDateView(entry, textStyles),
      downloadAs: getDownloadAsView(executeAction, styles.container),
      date: getDateView(entry, textStyles),
      dateTime: getDateView(entry, textStyles),
      transactionDateTime: getDateView(entry, textStyles),
      action: getActionView(entry.value, executeAction, false, getStatus(), from, downloadFileAction),
      ERN: getErnView(entry.value),
      rewards: getRewardView(entry.value, textStyles),
      sourceSystem: defaultView(true),
      url: (
        <CopyView
          entry={entry}
          statusStyle={statusStyle}
          textStyles={textStyles}
          isHovering={isHovering}
          copied={copied}
          setCopied={setCopied}
        />
      ),
      downloadDelete: getDownloadDeleteView(data, downloadReportFile, deleteReportFile, styles.container),
      editDelete: getEditDeleteView(data, editReportFile, deleteReportFile, styles.container),
    }

    return getView[entry.id.toString()] ?? defaultView()
  }

  const isActionItem =
    (entry.id.toString() === 'action' && entry.value === 'EXPORT') || entry.id.toString() === 'refundProcess'
  return (
    <>
      {data.id === '0' && (
        <Box {...viewStylesInner} {...extedndedWidth} key={transactionType + entry.id}>
          <Text {...statusStyle} {...textStyles}>
            {isStringBlank(value) ? '' : value}
          </Text>
          {entry.sortAllow && (
            <Box onPress={sort} testID="sort" paddingLeft={2}>
              <Image source={getSortImage()} width={16} height={16} />
            </Box>
          )}
        </Box>
      )}
      {data.id !== '0' && data.id !== tableItemStrings.loading && (
        <Box {...styles.gridStyle} {...extedndedWidth} key={entry.id}>
          <Box {...viewStylesInner} {...extedndedWidth} padding={isActionItem ? 4 : 16}>
            {getAction()}
          </Box>
          {!!bubbleValue && <BubbleView hide={bubbleValue.toLowerCase() === 'delete'} label={bubbleValue} />}
        </Box>
      )}
    </>
  )
}

export { ItemView }
